import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';
import './ModalCambioPassword.css';

const ModalCambioPassword = ({ onClose }) => {
  const [nueva, setNueva] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading] = useState(false);
  const [exito, setExito] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setError('');

    if (!nueva || !confirmar) {
      setError('Completá los dos campos.');
      return;
    }
    if (nueva.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (nueva !== confirmar) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    const { error: err } = await supabase.auth.updateUser({ password: nueva });
    setLoading(false);

    if (err) {
      setError(err.message || 'Ocurrió un error. Intentá de nuevo.');
    } else {
      setExito(true);
      setTimeout(() => onClose(), 2000);
    }
  };

  return (
    <div className="mcp-overlay" onClick={(e) => { if (e.target.className === 'mcp-overlay') onClose(); }}>
      <div className="mcp-card">
        <div className="mcp-header">
          <h3 className="mcp-titulo">Cambiar Contraseña</h3>
          <button className="mcp-close" onClick={onClose}>×</button>
        </div>

        {exito ? (
          <div className="mcp-exito">
            <span className="mcp-exito-icon">✓</span>
            <p>¡Contraseña actualizada!</p>
          </div>
        ) : (
          <>
            <div className="mcp-campo">
              <label>Nueva contraseña</label>
              <input
                type="password"
                placeholder="Mínimo 6 caracteres"
                value={nueva}
                onChange={(e) => setNueva(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              />
            </div>
            <div className="mcp-campo">
              <label>Confirmar contraseña</label>
              <input
                type="password"
                placeholder="Repetí la contraseña"
                value={confirmar}
                onChange={(e) => setConfirmar(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              />
            </div>

            {error && <p className="mcp-error">{error}</p>}

            <button
              className="mcp-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Actualizando...' : 'Confirmar cambio'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ModalCambioPassword;